import {
    ChangeDetectionStrategy,
    Component,
    inject,
    output,
} from '@angular/core';
import { LoaderComponent } from '@interacta-shared/ui';
import { AIConvoAgentListItemComponent } from '@modules/ai-convo/components/ai-convo-agent-item/ai-convo-agent-list-item.component';
import { AIConvoAgent } from '@modules/ai-convo/models/ai-convo-agent.model';
import {
    selectAIConvoAgents,
    selectAIConvoAgentsFetching,
} from '@modules/ai-convo/store/ai-convo.selectors';
import { Store } from '@ngrx/store';

@Component({
    selector: 'interacta-ai-convo-agents-panel',
    templateUrl: './ai-convo-agents-panel.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AIConvoAgentListItemComponent, LoaderComponent],
})
export class AIConvoAgentsPanelComponent {
    readonly back = output<void>();
    readonly agentSelected = output<AIConvoAgent>();

    private readonly store = inject(Store);

    readonly agents = this.store.selectSignal(selectAIConvoAgents);
    readonly agentsFetching = this.store.selectSignal(
        selectAIConvoAgentsFetching,
    );
}
